import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { LocalizableMessage, LocalizableMessageShape } from 'components/LocalizableMessage/LocalizableMessage';
import { decorateWith } from 'helpers/decorator';
import trackDwell from 'decorators/TrackDwell/TrackDwell';
import { ga } from 'helpers/multitrack';
import { isLoggedIn } from 'redux/saga/selectors/user';
import { waitlistRequest } from 'redux/saga/entities/bound';
import { isEmpty } from 'helpers/verify';
import { LeadGenFormContainer } from 'features/LeadGenForm/LeadGenFormContainer';
import { messages } from './LeadGen.messages';

var noop = function noop() {};

export var LeadGenUnwrapped =
/*#__PURE__*/
function (_Component) {
  _inherits(LeadGenUnwrapped, _Component);

  function LeadGenUnwrapped(props) {
    var _this;

    _classCallCheck(this, LeadGenUnwrapped);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LeadGenUnwrapped).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "hideModule", function () {
      return _this.setState({
        shouldHide: true
      });
    });

    var hideOnLoad = _this.props.hideOnLoad;
    _this.state = {
      shouldHide: hideOnLoad
    };
    return _this;
  }

  _createClass(LeadGenUnwrapped, [{
    key: "onDwell",
    value: function onDwell() {
      ga('Cms Page', 'View Module', 'LeadGen', 0, {
        nonInteraction: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.shouldHide) {
        return false;
      }

      var _this$props = this.props,
          backgroundColor = _this$props.backgroundColor,
          canHide = _this$props.canHide,
          ctaCopy = _this$props.ctaCopy,
          singleLineBreakpoint = _this$props.singleLineBreakpoint,
          submissionType = _this$props.submissionType,
          subtitleCopy = _this$props.subtitleCopy,
          titleCopy = _this$props.titleCopy,
          useMarketingStyles = _this$props.useMarketingStyles,
          wasCaptured = _this$props.wasCaptured;
      var leadGenClasses = classNames('lead-gen', {
        'lead-gen--marketing': useMarketingStyles,
        'bg--light': backgroundColor === 'light',
        'bg--white': backgroundColor === 'white',
        'anim anim--fadeOut lead-gen--anim-delay': canHide && wasCaptured
      });
      return React.createElement("div", {
        className: leadGenClasses,
        onAnimationEnd: canHide && wasCaptured ? this.hideModule : noop
      }, React.createElement("h2", {
        className: "lead-gen__title"
      }, React.createElement(LocalizableMessage, {
        message: titleCopy || messages.title
      })), React.createElement("p", {
        className: "lead-gen__subtitle"
      }, React.createElement(LocalizableMessage, {
        message: subtitleCopy || messages.subtitle
      })), React.createElement("div", {
        className: "lead-gen__form"
      }, React.createElement(LeadGenFormContainer, {
        ctaCopy: ctaCopy,
        singleLineBreakpoint: singleLineBreakpoint,
        submissionType: submissionType
      })));
    }
  }]);

  return LeadGenUnwrapped;
}(Component);
LeadGenUnwrapped.propTypes = {
  backgroundColor: PropTypes.oneOf(['white', 'light']),
  canHide: PropTypes.bool,
  ctaCopy: PropTypes.string,
  hideOnLoad: PropTypes.bool,
  submissionType: PropTypes.string,
  singleLineBreakpoint: PropTypes.string,
  subtitleCopy: LocalizableMessageShape,
  titleCopy: LocalizableMessageShape,
  useMarketingStyles: PropTypes.bool,
  wasCaptured: PropTypes.bool
};
export var mapStateToProps = function mapStateToProps(state, props) {
  var canHide = props.canHide;
  var wasCaptured = !isEmpty(waitlistRequest.data(state));
  return {
    hideOnLoad: isLoggedIn(state) || !!(canHide && wasCaptured),
    wasCaptured: wasCaptured
  };
};
export var LeadGen = decorateWith(connect(mapStateToProps), trackDwell)(LeadGenUnwrapped);